import { Box } from '@mui/material';
import React from 'react';
import BatteryGauge from './BatteryGauge';
import SocPlot from './SocPlot';

const BatteryCard = ({
  soc,
  statusText,
  series,
}) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
      <BatteryGauge
        soc={soc}
        statusText={statusText}
      />

      <SocPlot
        series={series}
        plotHeight={220}
      />
    </Box>
  )
}

export default BatteryCard;
